<template>
  <div class="contract">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="预约用户" prop="phone">
        <el-input :readonly="true" :value="ruleForm.name ? ruleForm.name + '-' + ruleForm.phone : '' + '-' + ruleForm.phone"></el-input>
      </el-form-item>
      <el-form-item label="用户地址" prop="id">
        <el-select
          v-model="ruleForm.id"
          @change="streetchange"
          placeholder="请选择用户地址"
          style="width: 100%"
        >
          <el-option
            :label="item.allAddress"
            :value="item.id"
            v-for="(item, key) in dreessList"
            :key="key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预约时间" prop="appointmentTimeBegin">
        <div class="timeBox">
          <div class="timeBox_l">
            <div
              v-for="(item, key) in arr"
              :key="key"
              @click="choiseTime(key, item)"
              :class="{ active: key == choisekey }"
            >
              <p>{{ item.monthdate }}</p>
              <p>{{ item.week }}</p>
            </div>
          </div>
          <div class="timeBox_r">
            <div class="timeBox_r_item">
              <div v-for="(item, key) in timeList" :key="key">
                <el-radio v-model="timeRadio" :label="item.id">
                  <span>{{ item.beginTime }}</span>
                  <span>-</span>
                  <span>{{ item.endTime }}</span>
                </el-radio>
              </div>
              <div v-if="timeList.length == 0" style="margin-top: 100px">当日暂无预约时间段</div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="预计重量" prop="grossWeight">
        <el-input type="number" v-model="ruleForm.grossWeight">
          <template slot="append">kg</template>
        </el-input>
      </el-form-item>
      <el-form-item label="备注" prop="userRemark">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 6 }"
          placeholder="请输入备注"
          v-model="ruleForm.userRemark"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="!isQuery">
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  statisticaladdressList,
  getAppointmentTimeList,
} from "@/api/management"
export default {
  name: "contract",
  props: ["isWhat", "userData", "isQuery"],
  data () {
    return {
      dreessList: [],
      arr: [],
      deepTimeList: [],
      choisekey: "",
      timeList: [],
      timeRadio: "",
      nowdate: "",
      ruleForm: {
        grossWeight: "",
        name: "",
        userId: "",
        appointmentTimeBegin: "",
        appointmentTimeEnd: "",
        cate: 2,
        phone: "",
        userRemark: "",
        wlCommunityId: "",
        wlUserAddress: "",
        wlUserAddressDetail: "",
      },
      rules: {
        phone: [{ required: true, message: "请选择预约用户", trigger: "blur" }],
        grossWeight: [
          { required: true, message: "请输入预计重量", trigger: "blur" },
        ],
        id: [
          { required: true, message: "请选择用户地址", trigger: "change" },
        ],
        appointmentTimeBegin: [
          { required: true, message: "请选择预约时间", trigger: "change" },
        ],
        userRemark: [
          { required: true, message: "请输入备注", trigger: "blur" },
        ],
      },
    }
  },
  computed: {},
  watch: {
    timeRadio (val) {
      if (val) {
        this.timeList.forEach((item) => {
          if (item.id == val) {
            const date = new Date()
            this.ruleForm.appointmentTimeBegin =
              date.getFullYear() +
              "-" +
              this.nowdate.replace("月", "-").replace("日", "") +
              " " +
              item.beginTime +
              ":00"
            this.ruleForm.appointmentTimeEnd =
              date.getFullYear() +
              "-" +
              this.nowdate.replace("月", "-").replace("日", "") +
              " " +
              item.endTime +
              ":00"
            this.$refs.ruleForm.validateField("appointmentTimeBegin")
          }
        })
      } else {
        this.ruleForm.appointmentTimeBegin = ""
        this.ruleForm.appointmentTimeEnd = ""
      }
    },
  },
  methods: {
    choiseTime (key, item) {
      this.choisekey = key
      this.timeRadio = ""
      this.nowdate = this.arr[key].monthdate
      const date = new Date()
      const hour = date.getHours()
      if (item.week == "今天") {
        for (let i = 0; i < this.timeList.length; i++) {
          if (this.timeList[i].endTime.substr(0, 2) - 0 < hour) {
            this.timeList.splice(i, 1)
            i--
          }
        }
      } else {
        this.timeList = JSON.parse(JSON.stringify(this.deepTimeList))
      }
    },
    getTimeDate () {
      let a = new Date()
      let year = a.getFullYear()
      let month = a.getMonth()
      let date = a.getDate()
      let day = a.getDay()
      this.arr = []
      for (let i = 0; i < 7; i++) {
        let d = new Date(year, month, date)
        let m = d.getMonth() + 1
        m = m < 10 ? "0" + m : m
        let r = d.getDate()
        r = r < 10 ? "0" + r : r
        let monthdate = m + "月" + r + "日"
        let week = d.getDay()

        if (week == day) {
          week = "今天"
        } else if (week == day + 1 || week == day - 6) {
          week = "明天"
        }
        switch (week) {
          case 0:
            week = "周日"
            break
          case 1:
            week = "周一"
            break
          case 2:
            week = "周二"
            break
          case 3:
            week = "周三"
            break
          case 4:
            week = "周四"
            break
          case 5:
            week = "周五"
            break
          case 6:
            week = "周六"
            break
        }
        this.arr.push({ monthdate, week })
        date++
      }
    },
    getgetAppointmentTimeList () {
      getAppointmentTimeList({}).then((res) => {
        if (res.code == 200) {
          this.timeList = res.data
          this.deepTimeList = JSON.parse(JSON.stringify(this.timeList))
          const date = new Date()
          const hour = date.getHours()
          console.log(res.data);
          console.log(hour);
          for (let i = 0; i < this.timeList.length; i++) {
            if (this.timeList[i].endTime.substr(0, 2) - 0 < hour) {
              this.timeList.splice(i, 1)
              i--
            }
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getstatisticaladdressList () {
      statisticaladdressList({ userId: this.userData.userId }).then((res) => {
        if (res.code == 200) {
          this.dreessList = res.data
          this.dreessList.forEach((item) => {
            item.allAddress = item.addressName + "-" + item.addressDetails
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    streetchange (val) {
      console.log(val);
      this.dreessList.forEach((item) => {
        if (val == item.id) {
          this.ruleForm.wlUserAddress = item.addressName
          this.ruleForm.wlUserAddressDetail = item.addressDetails
          this.ruleForm.wlCommunityId = item.wlCommunityId
          this.ruleForm.phone = item.mobile
          this.ruleForm.allAddress = item.addressDetails
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveSubmit", this.ruleForm)
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
  },
  created () {
    this.ruleForm.name = this.userData.nickname
    this.ruleForm.phone = this.userData.phone
    this.ruleForm.userId = this.userData.userId
    this.ruleForm.cate = 2
    this.getstatisticaladdressList()
    this.getgetAppointmentTimeList()
    this.getTimeDate()
    this.choiseTime(0, this.arr[0])
  },
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='‘number’'] {
  -moz-appearance: textfield !important;
}
.contract {
  padding: 24px;
  padding-top: 0px;
  .timeBox {
    width: 100%;
    height: 240px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    display: flex;
    overflow: hidden;
    .timeBox_l {
      width: 30%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.1);
      overflow: auto;
      p {
        text-align: center;
        height: 16px;
        line-height: 16px;
      }
      div {
        border: 1px solid transparent;
        cursor: pointer;
      }
    }
    .timeBox_r {
      .timeBox_r_item {
        margin-left: 40px;
        margin-top: 50px;
      }
    }
  }
  .active {
    background-color: #fff;
  }
}
</style>
